var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-md": "", "text-xs-center": "" } },
    [
      _c(
        "v-layout",
        {
          staticClass: "locked-layout",
          attrs: { column: "", "align-center": "" }
        },
        [
          _c("v-flex", { attrs: { xs12: "" } }, [
            _c(
              "p",
              {
                staticClass: "display-1 text--darken-1",
                attrs: { id: "override-font-family" }
              },
              [_vm._v("\n        " + _vm._s(_vm.textInfoHeader) + "\n      ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c("viewer", {
                staticClass: "subtitle text--darken-1",
                staticStyle: { "text-align": "center" },
                attrs: { data: _vm.textInfoSubHeader }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-icon",
                { staticClass: "warning-icon", attrs: { size: "90" } },
                [_vm._v(" warning ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }